import { GoalFilterDocument, GoalType } from '@griply/types';
import { filterRoadmapOverviewGoals, getWeekStartsOn } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUser } from 'shared/hooks/use-user';

export type UseGoalsOverviewFilteredGoalsOptions = {
  filterDocument: GoalFilterDocument;
  showCompleted: boolean;
  goalTypes: GoalType[];
};

export const useGoalsOverviewFilteredGoals = ({
  filterDocument,
  showCompleted,
  goalTypes,
}: UseGoalsOverviewFilteredGoalsOptions) => {
  const user = useUser();
  const today = useToday();
  const weekStartsOn = getWeekStartsOn(user);
  const sortedGoals = useSortedGoals();
  const links = useEntityLinks();

  const roadmapSettings = user?.settings?.goalsOverview?.roadmap;

  return useMemo(
    () =>
      filterRoadmapOverviewGoals(sortedGoals, {
        roadmapSettings,
        showCompleted,
        goalTypes,
        filterDocument,
        links,
        today,
        weekStartsOn,
      }),
    [
      links,
      roadmapSettings,
      sortedGoals,
      filterDocument,
      showCompleted,
      goalTypes,
      today,
      weekStartsOn,
    ],
  );
};
